<script lang="ts">
	import { twMerge } from "tailwind-merge";
	import ContentEditable from "#lib/components/ContentEditable.svelte";
	import { getDefaultFieldTitle } from "#lib/components/page/components/form/defaultValue.js";

	interface Props {
		value: string;
		name?: string;
		required?: boolean;
		onChange?: (value: string | undefined) => void;
		onCommit?: (value: string | undefined) => void;
	}

	let { value = $bindable(), name = "Field Title", required = false, onChange, onCommit }: Props = $props();
</script>

<ContentEditable onFocusout={() => !value && (value = getDefaultFieldTitle(name))} bind:value class={twMerge("text-sm font-medium focus:ring-offset-2", required && "required")} {onChange} {onCommit} />
